import { Component, ChangeDetectionStrategy, Inject, DOCUMENT } from '@angular/core';
import { ActivityTaskOverviewComponent } from '../activity-task-overview/activity-task-overview.component';
import { ActivityTaskPaneComponent } from '../activity-task-pane/activity-task-pane.component';
import { GoDialogRef } from '@go-modules/services/go-dialog-ref/go-dialog-ref';
import { ActivityEditModeService } from '@go-modules/services/activity-edit-mode/activity-edit-mode.service';

@Component({
	selector: 'activity-task-overview-and-pane',
	imports: [
		ActivityTaskOverviewComponent,
		ActivityTaskPaneComponent
	],
	templateUrl: './activity-task-overview-and-pane.component.html',
	styleUrls: ['./activity-task-overview-and-pane.component.scss'],
	changeDetection: ChangeDetectionStrategy.Default
})
export class ActivityTaskOverviewAndPaneComponent {
	public get isEditMode (): boolean {
		return this.activityEditModeService.isEditMode();
	}

	constructor (
		private dialogRef: GoDialogRef,
		private activityEditModeService: ActivityEditModeService,
		@Inject(DOCUMENT) private document: Document
	) {}

	public onTaskSelected (task) {
		this.document.querySelector('.overlay-panel.animated').classList.add('closing');
		setTimeout(() => {
			this.dialogRef.close(task);
		}, 250);
	}
}
